export default [
    {
        path: '/setting',
        component: () => import('@/views/setting')
    },   
    {
        path: '/setting/common-problem',
        component: () => import('@/views/setting/common-problem')
    },
    {
        path: '/setting/common-problem2',
        component: () => import('@/views/setting/common-problem2')
    },
    {
        path: '/setting/course-sales-statistics',
        component: () => import('@/views/setting/course-sales-statistics')
    },   
    {
        path: '/setting/subscription-price',
        component: () => import('@/views/setting/subscription-price')
    },   
    {
        path: '/setting/teaching-picture',
        component: () => import('@/views/setting/teaching-picture')
    },   
    {
        path: '/setting/courseUsageAnalysisReport',
        component: () => import('@/views/setting/course-usage-analysis-report')
    },   
    {
        path: '/setting/addCourseUsageAnalysisReport',
        component: () => import('@/views/setting/addCourseUsageAnalysisReport')
    },   
    {
        path: '/setting/editCourseUsageAnalysisReport/:id',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/setting/editCourseUsageAnalysisReport')
    },   
    {
        path: '/setting/payment-management',
        component: () => import('@/views/setting/payment-management')
    },   
    {
        path: '/setting/automatic-upgrade-time',
        component: () => import('@/views/setting/automatic-upgrade-time')
    },
    {
        path: '/learningRankingList',
        component: () => import('@/views/setting/learningRankingList')
    }
]